export default {
    stickers: {
        title: 'Pegatinas',
        stickerOpacity: 'Opacidad de la pegatina',
        stickerColor: 'Color de la pegatina',
        shapes: {
            title: 'Formas',
            rectangle: 'Rectángulo',
            circle: 'Círculo',
            triangle: 'Triángulo',
        },
        emojis: {
            title: 'Emojis',
        },
    },
};
